import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Redirect, Link } from "react-router-dom";
import { getJobPostsByTerms } from "../../actions/job";

import LoggedOutNav from "../layout/IME/LoggedOutNav";
import LoggedInNavHome from "../layout/IME/LoggedInNavHome";
import JobSearchInputs from "../layout/Employers/JobSearchInputs";
import HomeFooter from "../layout/IME/HomeFooter";
import OnlineUsers from "../layout/IME/OnlineUsers";
import RecommendedUsers from "../layout/IME/RecommendedUsers";
import JobMiniStream from "../layout/Employers/JobMiniStream";
import MentorMiniLiveStream from "../layout/Mentors/MentorMiniLiveStream";

import MiniDiscussionStream from "../layout/Innovators/MiniDiscussionStream";
import TwoFARequest from "../layout/Innovators/TwoFARequest";

const Home = ({
  auth: { user, channelid, jobtitle, location, verified },
  job: { jobs },
  isAuthenticated,
  getJobPostsByTerms,
}) => {
  // if (jobs && jobs.length > 0) {
  //   return <Redirect to={`/jobs`} />;
  // }

  const [showAuthentication, setShowAuthentication] = useState(true);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNavHome />}
      {!isAuthenticated && <LoggedOutNav />}
      <div className="home-vh">
        <div className="flex-only-container">
          <div className="side-container-home border-right grey">
            {!isAuthenticated && <RecommendedUsers />}
            {isAuthenticated && <OnlineUsers />}
          </div>
          <div className="home-container">
            <JobSearchInputs
              getJobPostsByTerms={getJobPostsByTerms}
              jobs={jobs}
            />
            <p className="section-border"></p>
            <div className="home-container-overflow">
              <div className="grid-rows">
                <p className="section-name-home white">
                  Trending <i className="fa-solid fa-chart-line white mx-5"></i>
                </p>
                <div className="row-grid">
                  <div className="scroll-arrows position-left">
                    <i className="fa-solid fa-chevron-left green cursor fa-2x"></i>
                  </div>
                  <div className="grid-item">
                    <div className="top-video-overlay-home">
                      <div className="user-overlay-info">
                        <div className="top-user-avi-container">
                          <div className="streamer-user-avi"></div>
                        </div>
                        <div className="helper-container">
                          <div className="stream-description-alt">
                            <p className="stream-username-title">
                              <span className="green mr-5 description-font">
                                UserName
                              </span>
                              <span className="white description-font-alt">
                                Job Title
                              </span>
                            </p>
                            <p className="stream-p-description">
                              Lorem ipsum dolor sit amet consectetur,
                              adipisicing elit. Nam ratione aut eaque dolor ea
                              temporibus laboriosam laborum recusandae odio
                              omnis.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="video-stream-live green">
                        <i className="fas fa-circle mx-5"></i>
                        Live
                      </div>
                      <div className="alt-left-controls">
                        <ul className="controls"></ul>
                      </div>
                      <div className="watch-stream-home">
                        <button className="watch-stream-button background-green">
                          Watch
                        </button>
                      </div>
                      <div className="stream-viewers-right white">
                        <i className="fas fa-user mx-5"></i>
                        82.7k
                      </div>
                    </div>
                    <video
                      muted
                      src={
                        "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/it_video.mp4"
                      }
                      className="home-video fill-video"
                    ></video>
                  </div>
                  <div className="grid-item">
                    <div className="top-video-overlay">
                      <div className="user-overlay-info">
                        <div className="top-user-avi-container">
                          <div className="streamer-user-avi"></div>
                        </div>
                        <div className="helper-container">
                          <div className="stream-description-alt">
                            <p className="stream-username-title">
                              <span className="green mr-5 description-font">
                                UserName
                              </span>
                              <span className="white description-font-alt">
                                Job Title
                              </span>
                            </p>
                            <p className="stream-p-description">
                              Lorem ipsum dolor sit amet consectetur,
                              adipisicing elit. Nam ratione aut eaque dolor ea
                              temporibus laboriosam laborum recusandae odio
                              omnis.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="video-stream-live green">
                        <i className="fas fa-circle mx-5"></i>
                        Live
                      </div>
                      <div className="alt-left-controls">
                        <ul className="controls"></ul>
                      </div>
                      <div className="watch-stream-home">
                        <button className="watch-stream-button background-green">
                          Watch
                        </button>
                      </div>
                      <div className="stream-viewers-right white">
                        <i className="fas fa-user mx-5"></i>
                        82.7k
                      </div>
                    </div>
                    <video
                      autoPlay
                      loop
                      muted
                      src={
                        "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/firetruck.mp4"
                      }
                      className="home-video fill-video"
                    ></video>
                  </div>
                  <div className="grid-item">
                    <div className="top-video-overlay-home">
                      <div className="user-overlay-info">
                        <div className="top-user-avi-container">
                          <div className="streamer-user-avi"></div>
                        </div>
                        <div className="helper-container">
                          <div className="stream-description-alt">
                            <p className="stream-username-title">
                              <span className="green mr-5 description-font">
                                UserName
                              </span>
                              <span className="white description-font-alt">
                                Job Title
                              </span>
                            </p>
                            <p className="stream-p-description">
                              Lorem ipsum dolor sit amet consectetur,
                              adipisicing elit. Nam ratione aut eaque dolor ea
                              temporibus laboriosam laborum recusandae odio
                              omnis.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="video-stream-live green">
                        <i className="fas fa-circle mx-5"></i>
                        Live
                      </div>
                      <div className="alt-left-controls">
                        <ul className="controls"></ul>
                      </div>
                      <div className="watch-stream-home">
                        <button className="watch-stream-button background-green">
                          Watch
                        </button>
                      </div>
                      <div className="stream-viewers-right white">
                        <i className="fas fa-user mx-5"></i>
                        82.7k
                      </div>
                    </div>
                    <video
                      muted
                      src={
                        "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/it_video.mp4"
                      }
                      className="home-video fill-video"
                    ></video>
                  </div>
                  <div className="scroll-arrows position-right">
                    <i className="fa-solid fa-chevron-right green cursor fa-2x"></i>
                  </div>
                </div>
              </div>
              <div className="grid-rows">
                <p className="section-border"></p>
                <p className="section-name-home white">
                  Recommended for you{" "}
                  <i className="fa-solid fa-sitemap white mx-5"></i>
                </p>
                <div className="created-content-home">
                  <div className="content-container">
                    <div className="stream-result-home">
                      <Link to="/liveonime/employers/stream_id">
                        <JobMiniStream />
                      </Link>
                    </div>
                  </div>
                  <div className="content-container">
                    <div className="stream-result-home">
                      <Link to="/liveonime/mentors/stream_id">
                        <MentorMiniLiveStream />
                      </Link>
                    </div>
                  </div>
                  <div className="content-container">
                    <div className="stream-result-home">
                      <Link to="/liveonime/mentors/stream_id">
                        <MiniDiscussionStream />
                      </Link>
                    </div>
                  </div>
                  <div className="content-container">
                    <div className="stream-result-home">
                      <Link to="/liveonime/mentors/stream_id">
                        <MiniDiscussionStream />
                      </Link>
                    </div>
                  </div>
                  <div className="content-container">
                    <div className="stream-result-home">
                      <Link to="/liveonime/mentors/stream_id">
                        <MiniDiscussionStream />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid-rows">
                <p className="section-border"></p>
                <p className="section-name-home white">
                  Best of Categorie Name
                  <i className="fa-solid fa-ranking-star white mx-10"></i>
                </p>
                <div className="created-content-home">
                  <div className="content-container">
                    <div className="stream-result-home">
                      <Link to="/liveonime/employers/stream_id">
                        <JobMiniStream />
                      </Link>
                    </div>
                  </div>
                  <div className="content-container">
                    <div className="stream-result-home">
                      <Link to="/liveonime/mentors/stream_id">
                        <MentorMiniLiveStream />
                      </Link>
                    </div>
                  </div>
                  <div className="content-container">
                    <div className="stream-result-home">
                      <Link to="/liveonime/mentors/stream_id">
                        <MiniDiscussionStream />
                      </Link>
                    </div>
                  </div>
                  <div className="content-container">
                    <div className="stream-result-home">
                      <Link to="/liveonime/mentors/stream_id">
                        <MiniDiscussionStream />
                      </Link>
                    </div>
                  </div>
                  <div className="content-container">
                    <div className="stream-result-home">
                      <Link to="/liveonime/mentors/stream_id">
                        <MiniDiscussionStream />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="secondary">
          <HomeFooter />
        </div>
      </div>
    </Fragment>
  );
};

Home.propTypes = {
  getJobPostsByTerms: PropTypes.func.isRequired,
  job: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  job: state.job,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { getJobPostsByTerms })(Home);
